export const NoSalesIllustraction = () => {
  return <div>No Sales</div>;
};
